import { ErrorHandler, inject } from '@angular/core';
import { ApplicationInsightsService } from './application-insights.service';

export class AppInsightsErrorHandler extends ErrorHandler {
    private readonly appInsights = inject(ApplicationInsightsService);

    override handleError(error: unknown): void {
        super.handleError(error);
        this.appInsights.trackException(error instanceof Error ? error : new Error(String(error)));
    }
}
